import Banner from '@/assets/banner/background.webp';
import PageBanner from '@/components/banner/PageBanner';
import { ContainerFluid } from '@/components/container/Container';
import { BodyLgHtml, H3 } from '@/components/ui/typography/Typography';

export default function KebijakanPrivasi() {
  const pageTitle = 'Kebijakan Privasi';

  return (
    <div>
      {/* Banner Halaman */}
      <PageBanner
        title={pageTitle}
        description="Kebijakan Privasi ini menjelaskan bagaimana kami mengumpulkan, menggunakan, dan melindungi informasi Anda saat mengakses layanan Koperasi Abdi Kerta Raharja."
        image={Banner}
      />

      <ContainerFluid className="py-16">
        <H3 className="mb-5">Kebijakan Privasi</H3>

        <BodyLgHtml
          className="text-xs md:text-sm leading-relaxed space-y-6"
          html={`
          Terakhir diperbarui: 6 Januari 2026
          <br />
          <br />
          Koperasi Abdi Kerta Raharja (selanjutnya disebut "Kami") menghargai privasi Anda dan
          berkomitmen untuk melindungi informasi pribadi yang Anda berikan saat mengakses dan
          menggunakan layanan kami. Kebijakan Privasi ini menjelaskan jenis informasi yang
          dikumpulkan, bagaimana informasi tersebut digunakan, disimpan, dan dijaga keamanannya.
          <br />
          <br />
          <strong>1. Informasi yang Kami Kumpulkan</strong>
          <br />
          a. <em>Informasi Non-Pribadi (Otomatis)</em>: Kami dapat mengumpulkan data seperti jenis
          perangkat, browser, halaman yang dikunjungi, durasi kunjungan, dan sumber trafik. Data ini
          dikumpulkan secara anonim dan digunakan untuk memahami penggunaan situs serta meningkatkan
          pengalaman pengguna.
          <br />
          b. <em>Informasi Pribadi</em>: Kami hanya mengumpulkan informasi pribadi yang Anda berikan
          secara sukarela melalui formulir atau kontak, seperti nama atau alamat email. Data ini
          digunakan untuk tujuan yang jelas dan sah, misalnya menanggapi pertanyaan atau layanan
          pelanggan.
          <br />
          <br />
          <strong>2. Penggunaan Cookie</strong>
          <br />
          Kami menggunakan cookie untuk meningkatkan pengalaman pengguna dan memahami interaksi
          dengan situs:
          <br />- <em>Cookie Analitik</em>: Digunakan untuk mengukur traffic, halaman populer, dan
          perilaku pengguna secara agregat. Cookie ini hanya diaktifkan setelah persetujuan Anda.
          <br />- <em>Cookie Pemasaran</em> (jika berlaku): Digunakan untuk menampilkan iklan
          relevan atau mengukur efektivitas kampanye. Cookie pemasaran hanya aktif setelah
          persetujuan eksplisit Anda.
          <br />
          <br />
          <strong>3. Dasar Hukum Pemrosesan Data</strong>
          <br />
          Pemrosesan data dilakukan berdasarkan persetujuan Anda dan kepentingan sah untuk
          meningkatkan performa situs serta keamanan pengguna.
          <br />
          <br />
          <strong>4. Pembagian Data</strong>
          <br />
          Kami tidak menjual atau menyewakan data pribadi Anda. Data hanya dibagikan kepada pihak
          ketiga yang mendukung operasional situs, dan hanya sejauh diperlukan serta sesuai
          persetujuan Anda.
          <br />
          <br />
          <strong>5. Keamanan dan Penyimpanan</strong>
          <br />
          Kami menerapkan langkah-langkah keamanan teknis dan organisasi untuk melindungi data dari
          akses tidak sah, kehilangan, atau penyalahgunaan. Data yang dikumpulkan disimpan selama
          diperlukan untuk tujuan analisis dan peningkatan layanan.
          <br />
          <br />
          <strong>6. Hak Pengguna</strong>
          <br />
          Pengguna memiliki hak untuk menarik kembali persetujuan cookie, meminta informasi terkait
          data yang disimpan, dan meminta penghapusan data tertentu sesuai ketentuan hukum yang
          berlaku. Untuk permintaan terkait privasi, silakan hubungi kami melalui halaman kontak.
          <br />
          <br />
          <strong>7. Perubahan Kebijakan Privasi</strong>
          <br />
          Kebijakan ini dapat diperbarui dari waktu ke waktu. Setiap perubahan akan ditampilkan di
          halaman ini dengan tanggal pembaruan terbaru. Kami menyarankan Anda untuk meninjau
          kebijakan ini secara berkala.
          <br />
          <br />
          <strong>8. Persetujuan</strong>
          <br />
          Dengan menggunakan situs ini dan/atau menyetujui penggunaan cookie melalui banner yang
          disediakan, Anda menyatakan telah membaca, memahami, dan menyetujui Kebijakan Privasi ini.
        `}
        />
      </ContainerFluid>
    </div>
  );
}
